import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Zap, ArrowRight } from 'lucide-react';
import api from '../api';

export default function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ full_name: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true); setError('');
    try {
      const res = await api.post('/auth/register', form);
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      navigate('/');
    } catch (err) { setError(err.response?.data?.detail || 'Registration failed'); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px 16px' }}>
      <div style={{ width: '100%', maxWidth: 420 }} className="fade-in">
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 32, justifyContent: 'center' }}>
          <div style={{ width: 34, height: 34, background: 'linear-gradient(135deg, #6366f1, #a855f7)', borderRadius: 9, display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 0 20px rgba(99,102,241,0.5)' }}>
            <Zap size={17} color="white" fill="white" />
          </div>
          <span style={{ fontFamily: 'Bebas Neue', fontSize: 20, letterSpacing: '0.05em' }}>ASTRAAUTOMATIONS</span>
        </div>

        <div style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: '28px 24px' }}>
          <h1 style={{ fontSize: 32, marginBottom: 4 }}>CREATE ACCOUNT</h1>
          <p style={{ color: 'var(--text2)', fontSize: 14, marginBottom: 24 }}>Start automating your business for free</p>

          <form onSubmit={submit}>
            <div style={{ marginBottom: 14 }}>
              <label>Full Name</label>
              <input placeholder="Your name" value={form.full_name} onChange={e => setForm({ ...form, full_name: e.target.value })} required autoFocus />
            </div>
            <div style={{ marginBottom: 14 }}>
              <label>Email Address</label>
              <input type="email" placeholder="you@company.com" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required />
            </div>
            <div style={{ marginBottom: 24 }}>
              <label>Password</label>
              <input type="password" placeholder="Min. 8 characters" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required minLength={8} />
            </div>
            {error && <div style={{ fontSize: 13, color: 'var(--red)', marginBottom: 16, padding: '11px 14px', background: 'var(--red-bg)', borderRadius: 8 }}>{error}</div>}
            <button className="btn btn-primary btn-lg" style={{ width: '100%', justifyContent: 'center' }} disabled={loading}>
              {loading ? 'Creating account...' : <><span>Get Started Free</span><ArrowRight size={16} /></>}
            </button>
          </form>

          <p style={{ textAlign: 'center', marginTop: 20, fontSize: 14, color: 'var(--text2)' }}>
            Already have an account?{' '}
            <Link to="/login" style={{ color: 'var(--accent3)', textDecoration: 'none', fontWeight: 700 }}>Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
